import { Box, Button, Container, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import axios from 'axios';
import { useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Branches from "../assets/images/Branches.png";
import Location from "../assets/images/Location.png";
import Notes from "../assets/images/Notes.png";
import Peoples from "../assets/images/Peoples.png";



import { configUrl } from '../config';
import { Footer } from '../MarketingSiteComponents/Footer';
import { Header } from '../MarketingSiteComponents/Header';

import ArrowForwardAltIcon from '@mui/icons-material/ArrowForward';
import PreferencelistTableBlur from '../assets/images/PreferencelistTableBlur.png';
import CollegePredictor from '../MarketingSiteComponents/CollegePredictor';
import ReviewSection from '../MarketingSiteComponents/ReviewSection';
import TrustStats from '../MarketingSiteComponents/TrustStats';
import WhatsappSubscription from '../MarketingSiteComponents/WhatsappSubscription';
const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: false,

    responsive: [
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};
const steps = [
    {
        number: "01",
        icon: <Box
            component="img"
            src={Notes}
            alt="Notes"
            sx={{
                width: { xs: 40, md: 55 },
                height: { xs: 40, md: 55 },
                objectFit: "contain",
            }}
        />,
        title: "Enter Your Rank",
        description: "Enter your rank/percentile to get started.",
        background: "#e8f8ef",
        color: "#25d366"
    },
    {
        number: "02",
        icon:
            <Box
                component="img"
                src={Peoples}
                alt="Peoples"
                sx={{
                    width: { xs: 40, md: 55 },
                    height: { xs: 40, md: 55 },
                    objectFit: "contain",
                }}
            />,
        title: "Select Category",
        description: "Choose your category (OPEN / OBC / SC / ST / EWS).",
        background: "#f3e8ff",
        color: "#7f5bab"
    },
    {
        number: "03",
        icon: <Box
            component="img"
            src={Branches}
            alt="Peoples"
            sx={{
                width: { xs: 40, md: 55 },
                height: { xs: 40, md: 55 },
                objectFit: "contain",
            }}
        />,
        title: "Preferred Branch",
        description: "Select your preferred branches like CS, IT, AI & DS, AI & ML etc.",
        background: "#e7eff5",
        color: "#1b4cb0"


    },
    {
        number: "04",
        icon: <Box
            component="img"
            src={Location}
            alt="Peoples"
            sx={{
                width: { xs: 40, md: 55 },
                height: { xs: 40, md: 55 },
                objectFit: "contain",
            }}
        />,
        title: "Preferred City",
        description: "Choose your preferred city to see the best college options.",
        background: "#fff4e5",
        color: "#ec9706"

    },
];
const GetCollegesListPdf = () => {
    const hasFetchedSubscriptions = useRef(false);
    const hasFetchedLandingCounts = useRef(false);
    const collegePredictorRef = useRef(null);

    const scrollToCollegePredictor = () => {
        collegePredictorRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
        });
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const navigate = useNavigate();
    const { referralCode } = useParams();
    const [openModal, setOpenModal] = useState(false);
    axios.defaults.headers.common = {
        providerId: configUrl.MediNeerProviderId,
        contentProviderIds: configUrl.MediNeerContentProviderIds
    };

    const [subscriptions, setSubscriptions] = useState(null);
    const [allCounts, setAllCounts] = useState(null);
    const [loadingSignUp, setSignUpLoading] = useState(false);

    let freeResourceId = 4;

    const series = {
        text: "WhatsAppSocialUpdates",
        subscriptionTypeId: null,
        courseId: null,
        price: 500,
        ResourceTypeIdData: 4
    };

    return (
        <Box id="hero" sx={{
            // background: 'linear-gradient(135deg, hsl(210 100% 15%), hsl(210 80% 25%))', 
            color: 'white',
            position: 'relative',
            overflow: 'hidden',
            pt: { xs: 8, md: 8.8 },
            pb: 0
        }}>
            {/* <Box sx={{ position: 'absolute', inset: 0, backgroundImage: `url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLW9wYWNpdHk9Ii4wNSIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9nPjwvc3ZnPg==')`, opacity: 0.1 }} /> */}
            <Header isHideOptions={true} />
            <Box
                sx={{
                    backgroundImage: `url(${PreferencelistTableBlur})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    position: "relative",
                    textAlign: "center",
                    py: {
                        xs: 4,
                        md: 10,
                    },
                    px: 2,
                    color: "#fff",
                }}
            >

                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        bgcolor: "rgba(0,0,0,.45)"
                    }}
                />

                <Container sx={{ position: "relative", zIndex: 2 }}>
                    {/* Get Personalized Preference List Now → */}
                    <Typography
                        sx={{
                            fontSize: {
                                xs: 23,
                                md: 39,
                            },
                            color: '#FFC107',
                            lineHeight: 1.2,
                            fontWeight: 700,
                            fontFamily: "Poppins",
                        }}
                    >
                        Get Personalized Preference List Now
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: {
                                xs: 28,
                                md: 44,
                            },
                            lineHeight: 2.2,
                            fontWeight: 700,
                            fontFamily: "Poppins",
                        }}
                    >
                        Based on Your Rank, Category, City & Branch
                    </Typography>

                    {/* <Typography
                        sx={{
                            mt: 1,
                            mb: 2,
                            fontSize: {
                                xs: 18,
                                md: 22,
                            },
                            lineHeight: 1.35,
                            px: {
                                xs: 1,
                                md: 0,
                            },
                        }}
                    >
                        Get Your College Preference List Instantly.
                    </Typography> */}
                    <Button
                        size="large"
                        variant="contained"
                        disableRipple
                        // startIcon={<WhatsAppIcon />}
                        endIcon={
                            <Box
                                component="span"
                                sx={{
                                    display: "inline-block",
                                    animation: "handBounce 1s infinite",
                                    "@keyframes handBounce": {
                                        "0%,100%": {
                                            transform: "translateY(0)",
                                        },
                                        "50%": {
                                            transform: "translateY(4px)",
                                        },
                                    },
                                }}
                            >
                                👇
                            </Box>
                        }
                        sx={{
                            bgcolor: "#1FAE4B",
                            color: '#fff',
                            px: 6,
                            py: 1.8,
                            mt: 2.8,
                            borderRadius: 2,
                            fontSize: {
                                xs: 18,
                                md: 24
                            },
                            textTransform: "none",
                            // cursor: "default !important",
                            "&:hover": {
                                bgcolor: "#1FAE4B",
                                color: '#fff',
                                // cursor: "default !important",
                            }
                        }}
                        // onClick={() => setOpenModal(true)}
                        onClick={scrollToCollegePredictor}

                    >
                        ₹ <span style={{ fontWeight: 600 }}> 500</span>&nbsp;only
                    </Button>

                    {/* <Box mt={4}>
                        <Button
                            size="large"
                            variant="contained"
                            // startIcon={<WhatsAppIcon fontSize='24'
                            // />}
                            sx={{
                                bgcolor: "#1FAE4B",
                                color: "#fff",
                                textTransform: 'capitalize',
                                width: {
                                    xs: "100%",
                                    sm: "auto"
                                },
                                maxWidth: 460,
                                py: {
                                    xs: 1.2,
                                    md: 1.5
                                },
                                fontSize: {
                                    xs: 16,
                                    md: 20
                                },
                                borderRadius: 2,
                                fontWeight: 700,
                                "&:hover": {
                                    bgcolor: "#1FAE4B"
                                }
                            }}
                            // onClick={handleJoinWhatsapp}
                            // onClick={() => setOpenModal(true)}
                            onClick={scrollToCollegePredictor}
                        >
                            Get Personalized Preference List Now →
                        </Button>
                    </Box> */}
                    <TrustStats />

                </Container>

            </Box>
            {/* feature section */}
            {/* <Box
                sx={{
                    bgcolor: "#fff",
                    mt: -1,
                    borderTop: "1px solid #eee",
                    borderBottom: "1px solid #eee",
                    boxShadow: "0 6px 20px rgba(0,0,0,.08)",
                }}
            >
                <Grid container>
                    {[
                        {
                            icon: <EmojiEventsIcon sx={{
                                fontSize: {
                                    xs: 40,
                                    md: 55
                                },
                                color: "#ffc107"
                            }} />,
                            title: "Rank",
                        },
                        {
                            icon: <Box
                                component="img"
                                src={Peoples}
                                alt="Peoples"
                                sx={{
                                    width: { xs: 40, md: 55 },
                                    height: { xs: 40, md: 55 },
                                    objectFit: "contain",
                                }}
                            />,
                            title: "Category",
                        },
                        {
                            icon: (<Box
                                component="img"
                                src={Branches}
                                alt="Branches"
                                sx={{
                                    width: { xs: 40, md: 55 },
                                    height: { xs: 40, md: 55 },
                                    objectFit: "contain",
                                }}
                            />),
                            title: "Branch",
                        },
                        {
                            icon: (<Box
                                component="img"
                                src={Location}
                                alt="Location"
                                sx={{
                                    width: { xs: 40, md: 55 },
                                    height: { xs: 40, md: 55 },
                                    objectFit: "contain",
                                }}
                            />),
                            title: "Preferred City",
                        },
                    ].map((item, index) => (
                        <Grid item xs={6} md={3} key={index}>
                            <Box
                                sx={{
                                    py: 4,
                                    px: 2,
                                    textAlign: "center",
                                    position: "relative",
                                    fontSize: 60,
                                    "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        top: "20%",
                                        right: 0,
                                        width: "1px",
                                        height: "60%",
                                        bgcolor: "#d8d8d8",
                                        display: {
                                            xs: index % 2 === 0 ? "block" : "none",
                                            md: index !== 3 ? "block" : "none",
                                        },
                                    },
                                }}
                            >
                                {item.icon}

                                <Typography
                                    sx={{
                                        mt: 1,
                                        fontWeight: 800,
                                        fontSize: {
                                            xs: 14,
                                            md: 19
                                        },
                                        color: "#012248",
                                        whiteSpace: "pre-line",
                                        lineHeight: 1.3,
                                        fontFamily: "Poppins"
                                    }}
                                >
                                    {item.title}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box> */}
            {/* How It Works */}
            {!isMobile && (
                <Box
                    sx={{
                        py: 8,
                        background: "#fff",
                    }}
                >
                    <Container maxWidth="xl">
                        {/* Heading */}

                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mb: 6,
                            }}
                        >
                            <Box
                                sx={{
                                    flex: 1,
                                    height: 2,
                                    bgcolor: "#D9E2F2",
                                    maxWidth: 260,
                                }}
                            />

                            <Typography
                                sx={{
                                    mx: 4,
                                    color: "#0A2D73",
                                    fontWeight: 700,
                                    fontSize: {
                                        xs: 28,
                                        md: 40,
                                    },
                                    fontFamily: "Poppins",
                                }}
                            >
                                How It Works?
                            </Typography>

                            <Box
                                sx={{
                                    flex: 1,
                                    height: 2,
                                    bgcolor: "#D9E2F2",
                                    maxWidth: 260,
                                }}
                            />
                        </Box>

                        {/* Cards */}

                        <Grid container spacing={3}>
                            {steps.map((step, index) => (
                                <Grid item xs={12} md={3} key={index}>
                                    <Box
                                        sx={{
                                            position: "relative",
                                        }}
                                    >
                                        {/* Arrow */}

                                        {index !== steps.length - 1 && (
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    right: -22,
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    width: 42,
                                                    height: 42,
                                                    borderRadius: "50%",
                                                    bgcolor: "#fff",
                                                    boxShadow: "0 4px 12px rgba(10,45,115,0.15)",
                                                    display: {
                                                        xs: "none",
                                                        md: "flex",
                                                    },
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    zIndex: 2,
                                                }}
                                            >
                                                <ArrowForwardAltIcon
                                                    sx={{
                                                        color: "#0A2D73",
                                                        fontSize: 26,
                                                    }}
                                                />
                                            </Box>
                                        )}
                                        {/* Card */}

                                        <Box
                                            sx={{
                                                height: "100%",
                                                minHeight: 250,
                                                borderRadius: 4,
                                                border: `5px solid ${step?.background}`,
                                                background: `${step?.background}`,
                                                boxShadow: "0 10px 30px rgba(0,0,0,.06)",
                                                p: 3,
                                                position: "relative",
                                            }}
                                        >
                                            {/* Number */}

                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: 16,
                                                    left: 16,
                                                    width: 42,
                                                    height: 42,
                                                    borderRadius: "50%",
                                                    bgcolor: `${step?.color}`,
                                                    color: "#fff",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    fontWeight: 700,
                                                }}
                                            >
                                                {step.number}
                                            </Box>

                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    mt: 6,
                                                    mb: 2,
                                                }}
                                            >
                                                {step.icon}
                                            </Box>

                                            <Typography
                                                sx={{
                                                    fontWeight: 700,
                                                    color: `${step?.color}`,
                                                    fontSize: 22,
                                                    textAlign: "center",
                                                    mb: 2,
                                                    fontFamily: "Poppins",
                                                }}
                                            >
                                                {step.title}
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color: "#5E6A7D",
                                                    fontSize: 15,
                                                    textAlign: "center",
                                                    lineHeight: 1.8,
                                                }}
                                            >
                                                {step.description}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Container>
                </Box>)}
            {/* College predictor */}
            <Box ref={collegePredictorRef}>
                <CollegePredictor
                // handleShowSubcription={handleShowSubcription} 
                />
            </Box>
            {/* Testimonials */}
            <Box
                sx={{
                    // py: 5,
                    px: 2,
                    bgcolor: "#fff",
                }}
            >
                <Container maxWidth="md">

                    {/* Heading */}
                    {/* <Box
                        sx={{
                            position: "relative",
                            textAlign: "center",
                            mb: 4,

                            "&::before": {
                                content: '""',
                                position: "absolute",
                                top: "50%",
                                left: 0,
                                width: "34%",
                                height: "2px",
                                bgcolor: "#d6dce5",
                                transform: "translateY(-50%)",
                            },

                            "&::after": {
                                content: '""',
                                position: "absolute",
                                top: "50%",
                                right: 0,
                                width: "34%",
                                height: "2px",
                                bgcolor: "#d6dce5",
                                transform: "translateY(-50%)",
                            },
                        }}
                    >
                        <Typography
                            sx={{
                                display: "inline-block",
                                px: 2,
                                bgcolor: "#fff",
                                position: "relative",
                                zIndex: 1,
                                color: "#0b4b91",
                                fontWeight: 700,
                                fontSize: {
                                    xs: 22,
                                    md: 28,
                                },
                                fontFamily: "Poppins",
                            }}
                        >
                            What Students Say
                        </Typography>
                    </Box> */}
                    <ReviewSection isSocialPage={true} />
                    {/* <Box
                        sx={{
                            background: "linear-gradient(180deg,#2f72c6,#1f63b8)",
                            borderRadius: 2,
                            p: 2,
                            boxShadow: "0 8px 18px rgba(0,0,0,.18)",
                            "& .slick-dots": {
                                bottom: "-28px",
                            },

                            "& .slick-dots li button:before": {
                                color: "#fff",
                                opacity: 0.5,
                                fontSize: "12px",
                            },

                            "& .slick-dots li.slick-active button:before": {
                                color: "#fff",
                                opacity: 1,
                            },

                            "& .slick-slide > div": {
                                padding: "0 8px",
                            },

                            "& .slick-list": {
                                margin: "0 -8px",
                            },
                        }}
                    >
                        <Slider {...settings}>

                            {[
                                {
                                    img: student2,
                                    quote: "“Got the best advice\nfor my admission!”",
                                    name: "Rajesh M."
                                },
                                {
                                    img: student1,
                                    quote: "“Very helpful and\nquick updates!”",
                                    name: "Ananya S."
                                },
                                {
                                    img: student2,
                                    quote: "“Got the best advice\nfor my admission!”",
                                    name: "Rajesh M."
                                },
                                {
                                    img: student1,
                                    quote: "“Very helpful and\nquick updates!”",
                                    name: "Ananya S."
                                },
                                {
                                    img: student2,
                                    quote: "“Got the best advice\nfor my admission!”",
                                    name: "Rajesh M."
                                },
                                {
                                    img: student1,
                                    quote: "“Very helpful and\nquick updates!”",
                                    name: "Ananya S."
                                }
                            ].map((item, index) => (
                                <Box key={index} px={1}>
                                    <Box
                                        sx={{
                                            bgcolor: "#fff",
                                            borderRadius: 2,
                                            p: 2,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            minHeight: 150,
                                        }}
                                    >
                                        <Grid
                                            item
                                            xs={12}
                                            md={6}
                                            key={index}
                                        >
                                            <Box
                                                sx={{
                                                    bgcolor: "#fff",
                                                    borderRadius: 1,
                                                    p: 2,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    minHeight: 140,
                                                }}
                                            >

                                                <Box
                                                    sx={{
                                                        flex: 1,
                                                        textAlign: "center",
                                                        pr: 2,
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontFamily: "Poppins",
                                                            fontWeight: 600,
                                                            fontStyle: "italic",
                                                            color: "#222",
                                                            fontSize: 18,
                                                            lineHeight: 1.45,
                                                            whiteSpace: "pre-line",
                                                        }}
                                                    >
                                                        {item.quote}
                                                    </Typography>

                                                    <Typography
                                                        sx={{
                                                            mt: 2,
                                                            fontSize: 16,
                                                            color: "#222",
                                                            fontWeight: 500,
                                                        }}
                                                    >
                                                        - {item.name}
                                                    </Typography>
                                                </Box>

                                                <Box
                                                    component="img"
                                                    src={item.img}
                                                    sx={{
                                                        width: 105,
                                                        height: 105,
                                                        borderRadius: 1,
                                                        objectFit: "cover",
                                                        flexShrink: 0,
                                                    }}
                                                />

                                            </Box>
                                        </Grid>

                                    </Box>
                                </Box>
                            ))}
                        </Slider>

                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                gap: 1.2,
                                mt: 2,
                            }}
                        ></Box>

                    </Box> */}

                </Container>
            </Box>
            {/* Bottom CTA */}
            <Box
                sx={{
                    py: 5,
                    px: 2,
                    bgcolor: "#fff",
                }}
            >
                <Container maxWidth="md">
                    {/* Heading */}
                    <Box
                        sx={{
                            position: "relative",
                            textAlign: "center",
                            mb: 4,

                            "&::before": {
                                content: '""',
                                position: "absolute",
                                top: "50%",
                                left: 0,
                                width: "34%",
                                height: "2px",
                                bgcolor: "#d6dce5",
                                transform: "translateY(-50%)",
                            },

                            "&::after": {
                                content: '""',
                                position: "absolute",
                                top: "50%",
                                right: 0,
                                width: "34%",
                                height: "2px",
                                bgcolor: "#d6dce5",
                                transform: "translateY(-50%)",
                            },
                        }}
                    >
                        <Typography
                            sx={{
                                display: "inline-block",
                                px: 2,
                                bgcolor: "#fff",
                                position: "relative",
                                zIndex: 1,
                                color: "#0b4b91",
                                fontWeight: 700,
                                fontSize: {
                                    xs: 22,
                                    md: 28,
                                },
                                fontFamily: "Poppins",
                            }}
                        >
                            Get Personalized Preference List Now ₹ 500
                        </Typography>
                    </Box>

                    <Button
                        variant="contained"
                        // startIcon={<WhatsAppIcon />}
                        sx={{
                            bgcolor: "#1FAE4B",
                            color: "#fff",
                            textTransform: 'capitalize',
                            width: {
                                xs: "100%",
                                sm: "auto"
                            },
                            // maxWidth: 460,
                            py: {
                                xs: 1.2,
                                md: 1.5
                            },
                            fontSize: {
                                xs: 16,
                                md: 20
                            },
                            borderRadius: 2,
                            fontWeight: 700,
                            "&:hover": {
                                bgcolor: "#1FAE4B"
                            }
                        }}
                        // sx={{
                        //     mt: 4,
                        //     bgcolor: "#1ea64b",
                        //     fontSize: 20,
                        //     px: 5,
                        //     py: 1.5,
                        //     textTransform: "none"
                        // }}
                        // onClick={() => setOpenModal(true)}
                        onClick={scrollToCollegePredictor}

                    >
                        Get Personalized Preference List Now @ ₹ 500
                    </Button>

                </Container>

            </Box>
            <Footer isHideOptions={true} />
            <WhatsappSubscription
                open={openModal}
                onClose={() => setOpenModal(false)}
                title="Join WhatsApp Group"
                price={500}
            />
        </Box >
    );
};
export default GetCollegesListPdf;